import { Button } from "@mantine/core";
import { showNotification } from "@mantine/notifications";
import { useState } from "react";
import { fetchLearnWorldsData } from "../../../utils/api/resources";
import { openNewTab } from "@/utils/browserUtils";

const VidLibraryButton = () => {
  const [loading, setLoading] = useState(false);

  const handleRedirect = async () => {
    try {
      setLoading(true);
      const data = await fetchLearnWorldsData();

      const redirectUrl = data.url;
      if (!redirectUrl) {
        throw new Error("No redirect URL found");
      }

      openNewTab(redirectUrl);
    } catch (error) {
      showNotification({
        title: "Error",
        message: "Could not complete the redirection process.",
        color: "red",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <Button
        onClick={handleRedirect}
        size="sm"
        className="start-tutorial-btn"
        radius="md"
        loading={loading}
      >
        View the video library
      </Button>
    </div>
  );
};

export default VidLibraryButton;
